import { GlobalAccountsHeader, GlobalAccountsCategories } from '@/components/influencers'

export function GlobalAccountsPage() {
  return (
    <div className="space-y-8">
      <GlobalAccountsHeader />
      <GlobalAccountsCategories />
    </div>
  )
} 